import styled from "styled-components";
import {
  UserWishListContainer,
  WishListCards,
} from "../../whishList/wishList.style";

export const AdminMyToursContainer = styled(UserWishListContainer)`
  padding: calc(6.4rem) 6.4rem 0 6.4rem;
`;

export const MyToursCards = styled(WishListCards)``;
